import React from 'react';
import { Home, Download, UserCircle } from 'lucide-react';
import { IDX_BASE_URL } from '../../../constants/site';
import { useAuth } from '../../../context/AuthContext';

const PILL_CLS = 'flex items-center space-x-2 bg-white/10 backdrop-blur-sm border border-white/30 text-white hover:bg-white/20 px-5 min-h-[44px] rounded-full transition-all text-sm font-semibold';

const GuideButton = ({ testId, label, onClick }) => (
  <button data-testid={testId} onClick={onClick} className="group relative flex items-center space-x-2 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-r from-gold-400 via-gold-300 to-gold-400 rounded-full animate-shimmer"></div>
    <div className="relative flex items-center space-x-2 bg-gradient-to-r from-gold-400 to-gold-500 hover:from-gold-300 hover:to-gold-400 text-[#143160] px-6 py-3 rounded-full font-bold shadow-lg shadow-gold-400/30 transition-all hover:scale-105 hover:shadow-xl hover:shadow-gold-400/40">
      <Download className="w-5 h-5" />
      <span>{label}</span>
      <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
    </div>
  </button>
);

export const HeroActions = ({ openGuideModal }) => {
  const { login } = useAuth();
  return (
    <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-6">
      <a href={IDX_BASE_URL} target="_blank" rel="noopener noreferrer" className={PILL_CLS}>
        <Home className="w-4 h-4" />
        <span>All Listings</span>
      </a>
      <button type="button" onClick={login} data-testid="hero-create-account" className={PILL_CLS}>
        <UserCircle className="w-4 h-4" />
        <span>Sign In / Save Searches</span>
      </button>
      <GuideButton testId="open-buyer-guide" label="FREE Buyer's Guide" onClick={() => openGuideModal('buyer')} />
      <GuideButton testId="open-seller-guide" label="FREE Seller's Guide" onClick={() => openGuideModal('seller')} />
    </div>
  );
};
